(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6619],{

/***/ 32990:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add/[[...currency]]",
      function () {
        return __webpack_require__(39623);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var CardFooter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
}).withConfig({
    componentId: "sc-cddac6ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardFooter);


/***/ }),

/***/ 97810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 14984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ZapCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19731);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  place-content: center;\n  background: ",
        ";\n  border-radius: 8px 0px 0px 0px;\n  border: 1px solid ",
        ";\n  border-right: none;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ZapCheckBoxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-4a3af06d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ZapCheckbox = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ZapCheckBoxWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            scale: "sm"
        }, props))
    });
};


/***/ }),

/***/ 40508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FlexGap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  & > * {\n    min-width: 280px;\n    max-width: 31.5%;\n    width: 100%;\n    margin: 0 8px;\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        ";\n  row-gap: ",
        ";\n  column-gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FlexLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e479e0f6-0"
})(_templateObject());
var FlexGap = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e479e0f6-1"
})(_templateObject1(), function(param) {
    var gap = param.gap;
    return gap;
}, function(param) {
    var rowGap = param.rowGap;
    return rowGap;
}, function(param) {
    var columnGap = param.columnGap;
    return columnGap;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexLayout);


/***/ }),

/***/ 49704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnsupportedCurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65528);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8253);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39475);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41914);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74314);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64011);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93293);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53854);
/* harmony import */ var _hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8f377946-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__/* .wrappedCurrency */ .pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,_hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__/* .useUnsupportedTokens */ .l6)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        title: t("Unsupported Assets"),
        maxWidth: "420px",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__/* .AutoRow */ .BA, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .CurrencyLogo */ .Xw, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .getBscScanLink */ .s6)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
};


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTransactionDeadline; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts


// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref, ref1;
    var multicall = (0,useContract/* useMulticallContract */.gq)();
    return (ref = (0,hooks/* useSingleCallResult */.Wk)(multicall, "getCurrentBlockTimestamp")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
};

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,es/* useSelector */.v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = useCurrentBlockTimestamp();
    return (0,react.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
};


/***/ }),

/***/ 39623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _currency_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var localization_src = __webpack_require__(8253);
// EXTERNAL MODULE: ./src/components/UnsupportedCurrencyFooter.tsx
var UnsupportedCurrencyFooter = __webpack_require__(49704);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(55878);
// EXTERNAL MODULE: ./src/utils/getLpSymbol.ts
var getLpSymbol = __webpack_require__(63119);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 3 modules
var calls = __webpack_require__(16519);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(42808);
// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 13 modules
var hooks = __webpack_require__(81081);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/config/constants/tokens.ts
var tokens = __webpack_require__(29748);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx + 1 modules
var CurrencyInputPanel = __webpack_require__(19527);
// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(45460);
// EXTERNAL MODULE: ./src/components/PositionCard/index.tsx
var PositionCard = __webpack_require__(86323);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(84915);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 1 modules
var useApproveCallback = __webpack_require__(50165);
// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts + 1 modules
var useTransactionDeadline = __webpack_require__(3620);
// EXTERNAL MODULE: ./src/state/mint/actions.ts
var actions = __webpack_require__(60650);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useTotalSupply.ts
var useTotalSupply = __webpack_require__(23552);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(7879);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(38472);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(97971);
// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 2 modules
var hooks_src = __webpack_require__(44589);
// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/index.ts + 34 modules
var state = __webpack_require__(46506);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(71900);
;// CONCATENATED MODULE: ./src/state/mint/hooks.ts

























function useMintState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.mint;
    });
}
function useMintActionHandlers(noLiquidity) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onFieldAInput = (0,react.useCallback)(function(typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    var onFieldBInput = (0,react.useCallback)(function(typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: actions/* Field.CURRENCY_B */.gN.CURRENCY_B,
            typedValue: typedValue,
            noLiquidity: noLiquidity === true
        }));
    }, [
        dispatch,
        noLiquidity
    ]);
    return {
        onFieldAInput: onFieldAInput,
        onFieldBInput: onFieldBInput
    };
}
function useDerivedMintInfo(currencyA, currencyB) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,useActiveWeb3React/* default */.Z)(), account = ref4.account, chainId = ref4.chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref5 = useMintState(), independentField = ref5.independentField, typedValue = ref5.typedValue, otherTypedValue = ref5.otherTypedValue;
    var dependentField = independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    // tokens
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    // pair
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,usePairs/* usePair */.yX)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]), 2), pairState = ref6[0], pair = ref6[1];
    var totalSupply = (0,useTotalSupply/* default */.Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var noLiquidity = pairState === usePairs/* PairState.NOT_EXISTS */._G.NOT_EXISTS || Boolean(totalSupply && src/* JSBI.equal */.QA.equal(totalSupply.raw, exchange/* BIG_INT_ZERO */.iV));
    // balances
    var balances = (0,wallet_hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
        currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], 
    ]);
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, balances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, balances[1]), _obj);
    // amounts
    var independentAmount = (0,tryParseAmount/* default */.Z)(typedValue, currencies[independentField]);
    var dependentAmount = (0,react.useMemo)(function() {
        if (noLiquidity) {
            if (otherTypedValue && currencies[dependentField]) {
                return (0,tryParseAmount/* default */.Z)(otherTypedValue, currencies[dependentField]);
            }
            return undefined;
        }
        if (independentAmount) {
            // we wrap the currencies just to get the price in terms of the other token
            var wrappedIndependentAmount = (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(independentAmount, chainId);
            var ref = [
                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return dependentCurrency === src/* ETHER */.c0 ? src/* CurrencyAmount.ether */.ih.ether(dependentTokenAmount.raw) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        noLiquidity,
        otherTypedValue,
        currencies,
        dependentField,
        independentAmount,
        currencyA,
        chainId,
        currencyB,
        pair
    ]);
    var parsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField
    ]);
    var price = (0,react.useMemo)(function() {
        if (noLiquidity) {
            var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
            if (currencyAAmount && currencyBAmount) {
                return new src/* Price */.tA(currencyAAmount.currency, currencyBAmount.currency, currencyAAmount.raw, currencyBAmount.raw);
            }
            return undefined;
        }
        var wrappedCurrencyA = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId);
        return pair && wrappedCurrencyA ? pair.priceOf(wrappedCurrencyA) : undefined;
    }, [
        chainId,
        currencyA,
        noLiquidity,
        pair,
        parsedAmounts
    ]);
    // liquidity minted
    var liquidityMinted = (0,react.useMemo)(function() {
        var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
        var ref = [
            (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(currencyAAmount, chainId),
            (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(currencyBAmount, chainId), 
        ], tokenAmountA = ref[0], tokenAmountB = ref[1];
        if (pair && totalSupply && tokenAmountA && tokenAmountB) {
            try {
                return pair.getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB);
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        parsedAmounts,
        chainId,
        pair,
        totalSupply
    ]);
    var poolTokenPercentage = (0,react.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new src/* Percent */.gG(liquidityMinted.raw, totalSupply.add(liquidityMinted).raw);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var error;
    var addError;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (pairState === usePairs/* PairState.INVALID */._G.INVALID) {
        error = error !== null && error !== void 0 ? error : t("Choose a valid pair");
    }
    var currencyAAmount = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], currencyBAmount = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    if (currencyAAmount && currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.equalTo(0)) && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.equalTo(0))) {
        error = error !== null && error !== void 0 ? error : t("No token balance");
    }
    if (!parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
        addError = t("Enter an amount");
    }
    if (currencyAAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(currencyAAmount))) {
        var ref7;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref7 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.symbol
        });
    }
    if (currencyBAmount && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref3 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(currencyBAmount))) {
        var ref8;
        addError = t("Insufficient %symbol% balance", {
            symbol: (ref8 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref8 === void 0 ? void 0 : ref8.symbol
        });
    }
    return {
        dependentField: dependentField,
        currencies: currencies,
        pair: pair,
        pairState: pairState,
        currencyBalances: currencyBalances,
        parsedAmounts: parsedAmounts,
        price: price,
        noLiquidity: noLiquidity,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        error: error,
        addError: addError
    };
}
var MAX_ZAP_REVERSE_RATIO = src/* JSBI.BigInt */.QA.BigInt(50);
var getMaxZapSwapAmount = function(pair, tokenZap) {
    return pair && tokenZap && pair.involvesToken(tokenZap) && src/* JSBI.divide */.QA.divide(pair.reserveOf(tokenZap).raw, MAX_ZAP_REVERSE_RATIO);
};
// simplify version to guess the zap in amount by swapInAmount from max zap reserves ratio 50
function guessMaxZappableAmount(pair, token0AmountIn, token1AmountIn) {
    if (!token1AmountIn) {
        if (token0AmountIn) {
            var maxSwapAmount = getMaxZapSwapAmount(pair, token0AmountIn.token);
            return maxSwapAmount && src/* JSBI.multiply */.QA.multiply(maxSwapAmount, src/* JSBI.BigInt */.QA.BigInt(2));
        }
        return undefined;
    }
    if (token0AmountIn && token1AmountIn) {
        var maxSwapAmount1 = getMaxZapSwapAmount(pair, token0AmountIn.token);
        if (!maxSwapAmount1) {
            return undefined;
        }
        var ref = (0,_sliced_to_array/* default */.Z)(pair.getInputAmount(new src/* TokenAmount */.dt(token0AmountIn.token, maxSwapAmount1)), 2), _ = ref[0], newPair = ref[1];
        return src/* JSBI.add */.QA.add(maxSwapAmount1, src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(token1AmountIn.raw, newPair.reserveOf(token0AmountIn.token).raw), newPair.reserveOf(token1AmountIn.token).raw));
    }
    return undefined;
}
// compare the gas is larger than swap in amount
function useZapInGasOverhead(inputAmount) {
    var ref;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var requiredGas = (0,lib_esm/* formatUnits */.bM)(gasPrice ? bignumber/* BigNumber.from */.O$.from(gasPrice).mul("500000") : "0");
    var requiredGasAsCurrencyAmount = inputAmount ? (0,tryParseAmount/* default */.Z)(requiredGas, src/* ETHER */.c0) : undefined;
    var inputIsBNB = (inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency.symbol) === "BNB";
    var gasCostInInputTokens = (0,Trades/* useTradeExactIn */.AU)(requiredGasAsCurrencyAmount, inputIsBNB ? null : inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency);
    var ref1;
    return (ref1 = gasCostInInputTokens === null || gasCostInInputTokens === void 0 ? void 0 : (ref = gasCostInInputTokens.outputAmount) === null || ref === void 0 ? void 0 : ref.greaterThan(inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.raw)) !== null && ref1 !== void 0 ? ref1 : false;
}
function useZapIn(param) {
    var canZap = param.canZap, currencyA = param.currencyA, currencyB = param.currencyB, pair = param.pair, currencyBalances = param.currencyBalances, zapTokenCheckedA = param.zapTokenCheckedA, zapTokenCheckedB = param.zapTokenCheckedB, maxAmounts = param.maxAmounts;
    var ref, ref1, ref2, ref3;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(false), inputBlurOnce = ref4[0], setInputBlurOnce = ref4[1];
    var previousBlur = (0,hooks_src/* usePreviousValue */.z)(inputBlurOnce);
    var ref5 = (0,react.useState)(false), triedAutoReduce = ref5[0], setTriedAutoReduce = ref5[1];
    var ref6 = useMintState(), independentField = ref6.independentField, typedValue = ref6.typedValue;
    var dependentField = independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, currencyA !== null && currencyA !== void 0 ? currencyA : undefined), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), _obj;
    }, [
        currencyA,
        currencyB
    ]);
    var independentAmount = (0,tryParseAmount/* default */.Z)(typedValue, currencies[independentField]);
    var _dependentAmount = (0,react.useMemo)(function() {
        if (!canZap) {
            return undefined;
        }
        if (independentAmount) {
            var wrappedIndependentAmount = (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(independentAmount, chainId);
            var ref = [
                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
            ], tokenA = ref[0], tokenB = ref[1];
            if (tokenA && tokenB && wrappedIndependentAmount && pair) {
                var dependentCurrency = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? currencyB : currencyA;
                var dependentTokenAmount = dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedIndependentAmount) : pair.priceOf(tokenB).quote(wrappedIndependentAmount);
                return dependentCurrency === src/* ETHER */.c0 ? src/* CurrencyAmount.ether */.ih.ether(dependentTokenAmount.raw) : dependentTokenAmount;
            }
            return undefined;
        }
        return undefined;
    }, [
        canZap,
        chainId,
        currencyA,
        currencyB,
        dependentField,
        independentAmount,
        pair
    ]);
    var isDependentAmountGreaterThanMaxAmount = maxAmounts[dependentField] && _dependentAmount && (_dependentAmount === null || _dependentAmount === void 0 ? void 0 : _dependentAmount.greaterThan(maxAmounts[dependentField]));
    // amounts
    var dependentAmount = (0,react.useMemo)(function() {
        return isDependentAmountGreaterThanMaxAmount ? maxAmounts[dependentField] : _dependentAmount;
    }, [
        isDependentAmountGreaterThanMaxAmount,
        maxAmounts,
        dependentField,
        _dependentAmount
    ]);
    var parsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, !zapTokenCheckedA ? undefined : independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? independentAmount : dependentAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, !zapTokenCheckedB ? undefined : independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? dependentAmount : independentAmount), _obj;
    }, [
        dependentAmount,
        independentAmount,
        independentField,
        zapTokenCheckedA,
        zapTokenCheckedB
    ]);
    var wrappedParsedAmounts = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], chainId)), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, (0,wrappedCurrency/* wrappedCurrencyAmount */.N)(parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId)), _obj;
    }, [
        chainId,
        parsedAmounts
    ]);
    var zapContract = (0,useContract/* useZapContract */.n9)();
    var rebalancing = !!zapTokenCheckedA && !!zapTokenCheckedB && !!parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !!parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var singleTokenToZapField = !rebalancing && zapTokenCheckedB && !!parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var singleTokenToZapAmount = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[singleTokenToZapField];
    }, [
        singleTokenToZapField,
        wrappedParsedAmounts
    ]);
    var noNeedZap = (0,react.useMemo)(function() {
        if (!rebalancing) {
            return false;
        }
        if (!wrappedParsedAmounts[independentField] || !wrappedParsedAmounts[dependentField]) {
            return undefined;
        }
        if (!isDependentAmountGreaterThanMaxAmount) {
            return true;
        }
        var ref = [
            (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
            (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
        ], tokenA = ref[0], tokenB = ref[1];
        if (tokenA && tokenB && wrappedParsedAmounts[independentField] && pair) {
            return wrappedParsedAmounts[dependentField].equalTo(dependentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B ? pair.priceOf(tokenA).quote(wrappedParsedAmounts[independentField]) : pair.priceOf(tokenB).quote(wrappedParsedAmounts[independentField]));
        }
        return undefined;
    }, [
        chainId,
        currencyA,
        currencyB,
        dependentField,
        independentField,
        isDependentAmountGreaterThanMaxAmount,
        pair,
        rebalancing,
        wrappedParsedAmounts, 
    ]);
    var singleZapEstimate = (0,useSWRContract/* useSWRContract */.Av)(canZap && !noNeedZap && zapContract && singleTokenToZapAmount && (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.token) && pair && !rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInSwap",
        params: [
            singleTokenToZapAmount.token.address,
            singleTokenToZapAmount.raw.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var rebalancingZapEstimate = (0,useSWRContract/* useSWRContract */.Av)(canZap && zapContract && !noNeedZap && wrappedParsedAmounts && wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pair && rebalancing && {
        contract: zapContract,
        methodName: "estimateZapInRebalancingSwap",
        params: [
            wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].token.address,
            wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].token.address,
            wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].raw.toString(),
            (ref = wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : (ref1 = ref.raw) === null || ref1 === void 0 ? void 0 : ref1.toString(),
            pair.liquidityToken.address, 
        ]
    }, {
        onError: function onError(err) {
            console.error(err);
        }
    });
    var zapInEstimated = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return ((rebalancingZapEstimate === null || rebalancingZapEstimate === void 0 ? void 0 : rebalancingZapEstimate.data) || (singleZapEstimate === null || singleZapEstimate === void 0 ? void 0 : singleZapEstimate.data)) && {
            swapAmountIn: rebalancing ? (ref = rebalancingZapEstimate.data) === null || ref === void 0 ? void 0 : ref.swapAmountIn : (ref1 = singleZapEstimate.data) === null || ref1 === void 0 ? void 0 : ref1.swapAmountIn,
            swapAmountOut: rebalancing ? (ref2 = rebalancingZapEstimate.data) === null || ref2 === void 0 ? void 0 : ref2.swapAmountOut : (ref3 = singleZapEstimate.data) === null || ref3 === void 0 ? void 0 : ref3.swapAmountOut,
            isToken0Sold: rebalancing ? (ref4 = rebalancingZapEstimate.data) === null || ref4 === void 0 ? void 0 : ref4.sellToken0 : ((ref5 = singleZapEstimate.data) === null || ref5 === void 0 ? void 0 : ref5.swapTokenOut) === (singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.token.address)
        };
    }, [
        rebalancing,
        rebalancingZapEstimate.data,
        singleZapEstimate.data,
        singleTokenToZapAmount === null || singleTokenToZapAmount === void 0 ? void 0 : singleTokenToZapAmount.token.address
    ]);
    var rebalancingSellToken0 = (0,react.useMemo)(function() {
        if (rebalancingZapEstimate.data) {
            return rebalancingZapEstimate.data.sellToken0;
        }
        if (!pair || !wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) {
            return undefined;
        }
        var token0toZap = pair.token0.equals(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].token);
        if (token0toZap) {
            return src/* JSBI.greaterThan */.QA.greaterThan(src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].raw, pair.reserve1.raw), src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].raw, pair.reserve0.raw));
        }
        return src/* JSBI.greaterThan */.QA.greaterThan(src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].raw, pair.reserve0.raw), src/* JSBI.multiply */.QA.multiply(wrappedParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].raw, pair.reserve1.raw));
    }, [
        pair,
        rebalancingZapEstimate.data,
        wrappedParsedAmounts
    ]);
    var swapTokenField = !rebalancing ? singleTokenToZapField : rebalancingSellToken0 ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B;
    var swapOutTokenField = swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A;
    var swapTokens = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, swapTokenField, (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[swapTokenField], chainId)), (0,_define_property/* default */.Z)(_obj, swapOutTokenField, (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[swapOutTokenField], chainId)), _obj;
    }, [
        chainId,
        currencies,
        swapOutTokenField,
        swapTokenField
    ]);
    var zapInEstimatedError = (0,react.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.error : singleZapEstimate.error;
    }, [
        rebalancing,
        rebalancingZapEstimate.error,
        singleZapEstimate.error
    ]);
    var zapInEstimatedStatus = (0,react.useMemo)(function() {
        return rebalancing ? rebalancingZapEstimate.status : singleZapEstimate.status;
    }, [
        rebalancing,
        rebalancingZapEstimate.status,
        singleZapEstimate.status
    ]);
    var priceImpact = (0,react.useMemo)(function() {
        if (!zapInEstimated) {
            return undefined;
        }
        var tokenAmountIn = new src/* TokenAmount */.dt(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString());
        var tokenAmountOut = new src/* TokenAmount */.dt(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
        var midPrice = src/* Price.fromRoute */.tA.fromRoute(new src/* Route */.AW([
            pair
        ], currencies[swapTokenField]));
        return (0,prices/* computePriceImpact */.o)(midPrice, tokenAmountIn, tokenAmountOut);
    }, [
        currencies,
        pair,
        swapOutTokenField,
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]);
    var overLimitZapRatio = (0,react.useMemo)(function() {
        if (!zapInEstimated) {
            return false;
        }
        return src/* JSBI.lessThan */.QA.lessThan(src/* JSBI.divide */.QA.divide(pair.reserveOf(swapTokens[swapTokenField]).raw, src/* JSBI.BigInt */.QA.BigInt(zapInEstimated.swapAmountIn.toString())), MAX_ZAP_REVERSE_RATIO);
    }, [
        pair,
        swapTokens,
        zapInEstimated,
        swapTokenField
    ]);
    var priceSeverity = overLimitZapRatio || zapInEstimatedError ? 4 : priceImpact ? (0,utils_exchange/* warningSeverity */.oX)(priceImpact) : 0;
    var ref7 = useMintActionHandlers(false), onFieldAInput = ref7.onFieldAInput, onFieldBInput = ref7.onFieldBInput;
    var maxZappableAmount = (0,react.useMemo)(function() {
        return guessMaxZappableAmount(pair, wrappedParsedAmounts[swapTokenField], rebalancing ? wrappedParsedAmounts[swapOutTokenField] : undefined);
    }, [
        pair,
        wrappedParsedAmounts,
        swapTokenField,
        rebalancing,
        swapOutTokenField
    ]);
    var convertToMaxZappable = (0,react.useCallback)(function() {
        if (maxZappableAmount) {
            if (maxAmounts[swapTokenField]) {
                var ref;
                var formatInput = (0,lib_esm/* formatUnits */.bM)(src/* JSBI.greaterThan */.QA.greaterThan(maxAmounts[swapTokenField].raw, maxZappableAmount) ? maxZappableAmount.toString() : maxAmounts[swapTokenField].raw.toString(), (ref = maxAmounts[swapTokenField]) === null || ref === void 0 ? void 0 : ref.currency.decimals);
                if (swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A) {
                    onFieldAInput(formatInput);
                } else {
                    onFieldBInput(formatInput);
                }
            }
        }
    }, [
        maxAmounts,
        maxZappableAmount,
        onFieldAInput,
        onFieldBInput,
        swapTokenField
    ]);
    var totalSupply = (0,useTotalSupply/* default */.Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    // liquidity minted
    var liquidityMinted = (0,react.useMemo)(function() {
        if (!pair || !swapTokens[swapTokenField] || !swapTokens[swapOutTokenField] || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn) || !(zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) || !wrappedParsedAmounts[swapTokenField]) {
            return undefined;
        }
        if (pair && totalSupply) {
            try {
                // calc the tokenA amount after swap
                var zappedTokenAmountA = wrappedParsedAmounts[swapTokenField].greaterThan(zapInEstimated.swapAmountIn.toString()) ? wrappedParsedAmounts[swapTokenField].subtract(new src/* TokenAmount */.dt(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString())) : wrappedParsedAmounts[swapTokenField];
                var zappedTokenAmountB = new src/* TokenAmount */.dt(swapTokens[swapOutTokenField], zapInEstimated.swapAmountOut.toString());
                if (wrappedParsedAmounts[swapOutTokenField]) {
                    zappedTokenAmountB = zappedTokenAmountB.add(wrappedParsedAmounts[swapOutTokenField]);
                }
                var lpMinted = pair.getLiquidityMinted(totalSupply, zappedTokenAmountA, zappedTokenAmountB);
                return lpMinted;
            } catch (error) {
                console.error(error);
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        swapTokens,
        swapTokenField,
        swapOutTokenField,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountIn,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        wrappedParsedAmounts,
        totalSupply, 
    ]);
    var swapTokenAmountTooLow = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[swapTokenField] && src/* JSBI.lessThan */.QA.lessThan(wrappedParsedAmounts[swapTokenField].raw, src/* MINIMUM_LIQUIDITY */.Xh);
    }, [
        swapTokenField,
        wrappedParsedAmounts
    ]);
    var swapOutAmountTooLow = (0,react.useMemo)(function() {
        return wrappedParsedAmounts[swapOutTokenField] && src/* JSBI.lessThan */.QA.lessThan(wrappedParsedAmounts[swapOutTokenField].raw, src/* MINIMUM_LIQUIDITY */.Xh);
    }, [
        swapOutTokenField,
        wrappedParsedAmounts
    ]);
    var poolTokenPercentage = (0,react.useMemo)(function() {
        if (liquidityMinted && totalSupply) {
            return new src/* Percent */.gG(liquidityMinted.raw, totalSupply.add(liquidityMinted).raw);
        }
        return undefined;
    }, [
        liquidityMinted,
        totalSupply
    ]);
    var gasOverhead = useZapInGasOverhead((0,react.useMemo)(function() {
        return zapInEstimated ? new src/* TokenAmount */.dt(swapTokens[swapTokenField], zapInEstimated.swapAmountIn.toString()) : null;
    }, [
        swapTokenField,
        swapTokens,
        zapInEstimated
    ]));
    (0,react.useEffect)(function() {
        if (!triedAutoReduce && parsedAmounts[swapTokenField] && maxZappableAmount && !previousBlur && inputBlurOnce && !rebalancing) {
            if (src/* JSBI.greaterThan */.QA.greaterThan(parsedAmounts[swapTokenField].raw, maxZappableAmount)) {
                convertToMaxZappable();
                setTriedAutoReduce(true);
            }
        }
    }, [
        convertToMaxZappable,
        inputBlurOnce,
        maxZappableAmount,
        parsedAmounts,
        previousBlur,
        rebalancing,
        singleTokenToZapAmount,
        swapTokenField,
        triedAutoReduce, 
    ]);
    var onInputBlurOnce = (0,react.useCallback)(function() {
        setInputBlurOnce(true);
    }, []);
    var error;
    if (zapInEstimatedError) {
        error = t("Cannot estimate zap amount");
    }
    if (swapTokenAmountTooLow || rebalancing && swapOutAmountTooLow) {
        error = t("Zap in amount too low");
    }
    if (wrappedParsedAmounts[swapTokenField] && ((ref2 = currencyBalances[swapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.lessThan(wrappedParsedAmounts[swapTokenField]))) {
        var ref8;
        var _symbol;
        error = t("Insufficient %token% balance", {
            token: (_symbol = (ref8 = wrappedParsedAmounts[swapTokenField]) === null || ref8 === void 0 ? void 0 : ref8.token.symbol) !== null && _symbol !== void 0 ? _symbol : ""
        });
    }
    if (wrappedParsedAmounts[swapOutTokenField] && rebalancing && ((ref3 = currencyBalances[swapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.lessThan(wrappedParsedAmounts[swapOutTokenField]))) {
        var ref9;
        var _symbol1;
        error = t("Insufficient %token% balance", {
            token: (_symbol1 = (ref9 = wrappedParsedAmounts[swapOutTokenField]) === null || ref9 === void 0 ? void 0 : ref9.token.symbol) !== null && _symbol1 !== void 0 ? _symbol1 : ""
        });
    }
    return {
        zapInEstimating: zapInEstimatedStatus !== types/* FetchStatus.Fetched */.iF.Fetched,
        zapInEstimatedError: zapInEstimatedError,
        zapInEstimated: zapInEstimated,
        error: error,
        liquidityMinted: liquidityMinted,
        poolTokenPercentage: poolTokenPercentage,
        parsedAmounts: parsedAmounts,
        swapTokenField: swapTokenField,
        swapOutTokenField: swapOutTokenField,
        priceSeverity: priceSeverity,
        convertToMaxZappable: convertToMaxZappable,
        rebalancing: rebalancing,
        noNeedZap: noNeedZap,
        gasOverhead: gasOverhead,
        isDependentAmountGreaterThanMaxAmount: isDependentAmountGreaterThanMaxAmount,
        onInputBlurOnce: onInputBlurOnce
    };
}

// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(45131);
// EXTERNAL MODULE: ./src/components/Loader/Dots.tsx
var Dots = __webpack_require__(48468);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/PoolPriceBar.tsx







function PoolPriceBar(param) {
    var currencies = param.currencies, noLiquidity = param.noLiquidity, poolTokenPercentage = param.poolTokenPercentage, price = param.price;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
            justify: "space-around",
            gap: "4px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref5 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref5 !== void 0 ? ref5 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref6 = (ref = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.symbol) !== null && ref6 !== void 0 ? ref6 : "",
                                assetB: (ref7 = (ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol) !== null && ref7 !== void 0 ? ref7 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (ref8 = (ref2 = price === null || price === void 0 ? void 0 : price.invert()) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("%assetA% per %assetB%", {
                                assetA: (ref9 = (ref3 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== null && ref9 !== void 0 ? ref9 : "",
                                assetB: (ref10 = (ref4 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref4 === void 0 ? void 0 : ref4.symbol) !== null && ref10 !== void 0 ? ref10 : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                noLiquidity && price ? "100" : (ref11 = (poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.lessThan(exchange/* ONE_BIPS */.IS)) ? "<0.01" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toFixed(2)) !== null && ref11 !== void 0 ? ref11 : "0",
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            pt: 1,
                            children: t("Share of Pool")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var AddLiquidity_PoolPriceBar = (PoolPriceBar);

// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx
var TransactionConfirmationModal = __webpack_require__(41228);
// EXTERNAL MODULE: ./src/state/burn/actions.ts
var burn_actions = __webpack_require__(52171);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/common.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Dot = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-d0b8194-0"
})(_templateObject());
var CircleSvg = function(_param) /*#__PURE__*/ {
    var _percent = _param.percent, percent = _percent === void 0 ? 1 : _percent, props = (0,_object_without_properties/* default */.Z)(_param, [
        "percent"
    ]);
    return (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "60px",
        height: "60px",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_1147_113741)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "10",
                        cx: "10",
                        cy: "10",
                        fill: "#7645D9"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        r: "5",
                        cx: "10",
                        cy: "10",
                        fill: "transparent",
                        stroke: "#1FC7D4",
                        strokeWidth: "10",
                        strokeDasharray: "calc(".concat(percent * 100, "px * 31.4 / 100) 31.4"),
                        transform: "rotate(-90) translate(-20)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_i_1147_113741",
                    x: 0,
                    y: 0,
                    width: 60,
                    height: 60,
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: -2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: -1,
                            k3: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in2: "shape",
                            result: "effect1_innerShadow_1147_113741"
                        })
                    ]
                })
            })
        ]
    }));
};
var Subtitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        fontSize: "12px",
        textTransform: "uppercase",
        bold: true,
        color: "secondary",
        children: children
    });
};
var PairDistribution = function(param) {
    var title = param.title, percent = param.percent, currencyA = param.currencyA, currencyB = param.currencyB, currencyAValue = param.currencyAValue, currencyBValue = param.currencyBValue, tooltipTargetRef = param.tooltipTargetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "8px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    typeof percent !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: tooltipTargetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleSvg, {
                            percent: percent,
                            mr: "34px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            currencyA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "primary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyA
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyA === null || currencyA === void 0 ? void 0 : currencyA.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyAValue
                                    })
                                ]
                            }),
                            currencyB && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                        gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                                                bg: "secondary"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                                currency: currencyB
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: currencyB === null || currencyB === void 0 ? void 0 : currencyB.symbol
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: currencyBValue
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AddLiquidityModalHeader = function(param) {
    var currencies = param.currencies, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, price = param.price, allowedSlippage = param.allowedSlippage, noLiquidity = param.noLiquidity, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref8 = (0,useTooltip/* default */.Z)(t("Output is estimated. If the price changes by more than %slippage%% your transaction will revert.", {
        slippage: allowedSlippage / 100
    }), {
        placement: "auto"
    }), tooltip = ref8.tooltip, tooltipVisible = ref8.tooltipVisible, targetRef = ref8.targetRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "24px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("You will receive")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* GreyCard */.h2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                    gap: "4px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                                            currency1: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            children: ((ref = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.symbol) && ((ref1 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.symbol) && (0,getLpSymbol/* getLPSymbol */.z)((ref2 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref2 === void 0 ? void 0 : ref2.symbol, (ref3 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "8px",
                                    children: liquidityMinted === null || liquidityMinted === void 0 ? void 0 : liquidityMinted.toSignificant(6)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Your pool share")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            noLiquidity ? "100" : poolTokenPercentage === null || poolTokenPercentage === void 0 ? void 0 : poolTokenPercentage.toSignificant(4),
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                gap: "8px",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: t("Rates")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "1 ".concat((ref4 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.toSignificant(4), " ").concat((ref5 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref5 === void 0 ? void 0 : ref5.symbol)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                        style: {
                            justifyContent: "flex-end"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "1 ".concat((ref6 = currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref6 === void 0 ? void 0 : ref6.symbol, " = ").concat(price === null || price === void 0 ? void 0 : price.invert().toSignificant(4), " ").concat((ref7 = currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.symbol)
                        })
                    })
                ]
            }),
            !noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("Slippage Tolerance")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
                        ref: targetRef,
                        children: [
                            allowedSlippage / 100,
                            "%"
                        ]
                    }),
                    tooltipVisible && tooltip
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmAddLiquidityModal.tsx







var ConfirmAddLiquidityModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, noLiquidity = param.noLiquidity, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, currencyToAdd = param.currencyToAdd;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            noLiquidity: noLiquidity,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                title: t("Input"),
                percent: 0.5,
                currencyA: currencies[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A],
                currencyAValue: (ref = parsedAmounts[burn_actions/* Field.CURRENCY_A */.g.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                currencyB: currencies[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B],
                currencyBValue: (ref1 = parsedAmounts[burn_actions/* Field.CURRENCY_B */.g.CURRENCY_B]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
            })
        });
    }, [
        allowedSlippage,
        currencies,
        liquidityMinted,
        noLiquidity,
        parsedAmounts,
        poolTokenPercentage,
        price,
        t
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: noLiquidity ? t("Create Pool & Supply") : t("Confirm Supply")
        });
    }, [
        noLiquidity,
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
            onDismiss: onDismiss,
            message: liquidityErrorMessage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        onDismiss,
        modalBottom,
        modalHeader,
        liquidityErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: currencyToAdd,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmAddLiquidityModal = (ConfirmAddLiquidityModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(6372);
// EXTERNAL MODULE: ./src/views/AddLiquidity/components/ZapErrorMessage.tsx
var ZapErrorMessage = __webpack_require__(52631);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/components/ConfirmZapInModal.tsx
















var clamp = function(num, min, max) {
    return Math.min(Math.max(num, min), max);
};
var ConfirmZapInModal = function(param) {
    var title = param.title, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, price = param.price, currencies = param.currencies, zapSwapTokenField = param.zapSwapTokenField, zapSwapOutTokenField = param.zapSwapOutTokenField, allowedSlippage = param.allowedSlippage, parsedAmounts = param.parsedAmounts, liquidityErrorMessage = param.liquidityErrorMessage, onAdd = param.onAdd, poolTokenPercentage = param.poolTokenPercentage, liquidityMinted = param.liquidityMinted, pair = param.pair, zapInEstimated = param.zapInEstimated, rebalancing = param.rebalancing, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode;
    var ref, ref1, ref2, ref3;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var totalPoolTokens = (0,useTotalSupply/* default */.Z)(pair.liquidityToken);
    var swapInCurrencyAmount = parsedAmounts[zapSwapTokenField];
    var swapOutCurrencyAmount = parsedAmounts[zapSwapOutTokenField];
    var ref4 = (0,useTooltip/* default */.Z)(swapInCurrencyAmount && !swapOutCurrencyAmount ? t("There is no %token1% input. Half of %token0% input is converted into %token1% to add liquidity.", {
        token0: (ref = currencies[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.symbol,
        token1: (ref1 = currencies[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.symbol
    }) : t("There is not enough %token1% input to match 50/50. Some of %token0% will be converted to %token1%", {
        token0: (ref2 = currencies[zapSwapTokenField]) === null || ref2 === void 0 ? void 0 : ref2.symbol,
        token1: (ref3 = currencies[zapSwapOutTokenField]) === null || ref3 === void 0 ? void 0 : ref3.symbol
    }), {
        placement: "auto-start"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    var ref5 = (0,_sliced_to_array/* default */.Z)(!!pair && !!totalPoolTokens && !!liquidityMinted && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    src/* JSBI.greaterThanOrEqual */.QA.greaterThanOrEqual(totalPoolTokens.raw, liquidityMinted.raw) ? [
        pair.getLiquidityValue(pair.token0, totalPoolTokens, liquidityMinted, false),
        pair.getLiquidityValue(pair.token1, totalPoolTokens, liquidityMinted, false), 
    ] : [
        undefined,
        undefined
    ], 2), token0Deposited = ref5[0], token1Deposited = ref5[1];
    var swapInTokenAmount = (0,react.useMemo)(function() {
        return zapInEstimated && new src/* TokenAmount */.dt((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapTokenField], chainId), zapInEstimated.swapAmountIn.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated,
        zapSwapTokenField
    ]);
    var swapOutTokenAmount = (0,react.useMemo)(function() {
        return (zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut) && new src/* TokenAmount */.dt((0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapSwapOutTokenField], chainId), zapInEstimated.swapAmountOut.toString());
    }, [
        chainId,
        currencies,
        zapInEstimated === null || zapInEstimated === void 0 ? void 0 : zapInEstimated.swapAmountOut,
        zapSwapOutTokenField
    ]);
    var inputPercent = (0,react.useMemo)(function() {
        return swapInCurrencyAmount && swapOutCurrencyAmount ? clamp(+pair.priceOf((0,wrappedCurrency/* wrappedCurrency */.pu)(swapOutCurrencyAmount.currency, chainId)).raw.divide(new src/* Price */.tA(swapInCurrencyAmount.currency, swapOutCurrencyAmount.currency, src/* JSBI.add */.QA.add(swapInCurrencyAmount.raw, swapOutCurrencyAmount.raw), swapInCurrencyAmount.raw)).toSignificant(2), 0.05, 0.95) : swapInCurrencyAmount && !swapOutCurrencyAmount ? 1 : undefined;
    }, [
        chainId,
        pair,
        swapInCurrencyAmount,
        swapOutCurrencyAmount
    ]);
    var tokenDeposited = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, zapSwapTokenField, (swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.token) && (pair === null || pair === void 0 ? void 0 : pair.token0) ? pair.token0.equals(swapInTokenAmount.token) ? token0Deposited : token1Deposited : undefined), (0,_define_property/* default */.Z)(_obj, zapSwapOutTokenField, (swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.token) && (pair === null || pair === void 0 ? void 0 : pair.token1) ? pair.token1.equals(swapOutTokenAmount.token) ? token1Deposited : token0Deposited : undefined), _obj;
    }, [
        pair.token0,
        pair.token1,
        swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.token,
        swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.token,
        token0Deposited,
        token1Deposited,
        zapSwapOutTokenField,
        zapSwapTokenField, 
    ]);
    var modalHeader = (0,react.useCallback)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddLiquidityModalHeader, {
            allowedSlippage: allowedSlippage,
            currencies: currencies,
            liquidityMinted: liquidityMinted,
            poolTokenPercentage: poolTokenPercentage,
            price: price,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                    title: t("Input"),
                    percent: inputPercent,
                    currencyA: swapInCurrencyAmount ? currencies[zapSwapTokenField] : undefined,
                    currencyAValue: swapInCurrencyAmount === null || swapInCurrencyAmount === void 0 ? void 0 : swapInCurrencyAmount.toSignificant(6),
                    currencyB: swapOutCurrencyAmount ? currencies[zapSwapOutTokenField] : undefined,
                    currencyBValue: swapOutCurrencyAmount === null || swapOutCurrencyAmount === void 0 ? void 0 : swapOutCurrencyAmount.toSignificant(6)
                }),
                swapOutTokenAmount && swapInTokenAmount && currencies[zapSwapTokenField] && currencies[zapSwapOutTokenField] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    justify: "center",
                    gap: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                            gap: "6px",
                            justify: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapInTokenAmount === null || swapInTokenAmount === void 0 ? void 0 : swapInTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapTokenField].symbol
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("to")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: swapOutTokenAmount === null || swapOutTokenAmount === void 0 ? void 0 : swapOutTokenAmount.toSignificant(6)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currencies[zapSwapOutTokenField]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: currencies[zapSwapOutTokenField].symbol
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                            color: "textSubtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "4px",
                    children: [
                        tooltipVisible && tooltip,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PairDistribution, {
                            tooltipTargetRef: targetRef,
                            title: t("Pooled"),
                            percent: 0.5,
                            currencyA: currencies[zapSwapTokenField],
                            currencyAValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref = tokenDeposited[zapSwapTokenField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6),
                            currencyB: currencies[zapSwapOutTokenField],
                            currencyBValue: tokenDeposited === null || tokenDeposited === void 0 ? void 0 : (ref1 = tokenDeposited[zapSwapOutTokenField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)
                        })
                    ]
                })
            ]
        });
    }, [
        allowedSlippage,
        currencies,
        liquidityMinted,
        poolTokenPercentage,
        price,
        t,
        inputPercent,
        swapInCurrencyAmount,
        zapSwapTokenField,
        swapOutCurrencyAmount,
        zapSwapOutTokenField,
        swapOutTokenAmount,
        swapInTokenAmount,
        tooltip,
        tooltipVisible,
        targetRef,
        tokenDeposited, 
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            onClick: onAdd,
            mt: "20px",
            children: t("Confirm Supply")
        });
    }, [
        onAdd,
        t
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return liquidityErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapErrorMessage/* ZapErrorMessages */.p, {
                    isSingleToken: !rebalancing,
                    zapMode: zapMode,
                    toggleZapMode: toggleZapMode,
                    onModalDismiss: onDismiss
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
                    onDismiss: onDismiss,
                    message: liquidityErrorMessage
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
            topContent: modalHeader,
            bottomContent: modalBottom
        });
    }, [
        liquidityErrorMessage,
        rebalancing,
        zapMode,
        toggleZapMode,
        onDismiss,
        modalHeader,
        modalBottom
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* default */.ZP, {
        minWidth: [
            "100%",
            ,
            "420px"
        ],
        title: title,
        onDismiss: onDismiss,
        customOnDismiss: customOnDismiss,
        attemptingTxn: attemptingTxn,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        hash: hash,
        content: confirmationContent,
        pendingText: pendingText
    });
};
/* harmony default export */ var components_ConfirmZapInModal = (ConfirmZapInModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(95596);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDropDown.tsx
var ArrowDropDown = __webpack_require__(97810);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 12 modules
var CurrencySearchModal = __webpack_require__(63439);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
;// CONCATENATED MODULE: ./src/components/CurrencySelect/index.tsx





function CurrencySelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  background: ",
        ";\n  transition: border-radius 0.15s;\n"
    ]);
    CurrencySelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  background: ",
        ";\n  border-radius: 16px;\n  height: 40px;\n  min-width: 136px;\n  user-select: none;\n  z-index: 20;\n\n  ",
        " {\n    min-width: 168px;\n  }\n\n  .down-icon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28d2a57d-0"
})(CurrencySelect_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var DropDownContainer = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-28d2a57d-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CurrencySelect = function(_param) {
    var onCurrencySelect = _param.onCurrencySelect, selectedCurrency = _param.selectedCurrency, otherSelectedCurrency = _param.otherSelectedCurrency, showCommonBases = _param.showCommonBases, hideBalance = _param.hideBalance, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCurrencySelect",
        "selectedCurrency",
        "otherSelectedCurrency",
        "showCommonBases",
        "hideBalance"
    ]);
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, !hideBalance && selectedCurrency ? selectedCurrency : undefined);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: selectedCurrency,
        otherSelectedCurrency: otherSelectedCurrency,
        showCommonBases: showCommonBases
    })), 1), onPresentCurrencyModal = ref[0];
    var price = (0,useBUSDPrice/* default */.ZP)(selectedCurrencyBalance && selectedCurrency ? selectedCurrency : undefined);
    var quoted = selectedCurrencyBalance && (price === null || price === void 0 ? void 0 : price.quote(selectedCurrencyBalance));
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, {
                p: 0,
                onClick: onPresentCurrencyModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            id: "pair",
                            color: !selectedCurrency ? "text" : undefined,
                            children: !selectedCurrency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: t("Select")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: selectedCurrency,
                                        size: "24px",
                                        style: {
                                            marginRight: "8px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        id: "pair",
                                        bold: true,
                                        children: selectedCurrency && selectedCurrency.symbol && selectedCurrency.symbol.length > 20 ? "".concat(selectedCurrency.symbol.slice(0, 4), "...").concat(selectedCurrency.symbol.slice(selectedCurrency.symbol.length - 5, selectedCurrency.symbol.length)) : selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.symbol
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                        color: "text",
                        className: "down-icon"
                    })
                ]
            }),
            account && !!selectedCurrency && !hideBalance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                        justify: "space-between",
                        gap: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "12px",
                                children: [
                                    t("Balance"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                children: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            Number.isFinite(+(quoted === null || quoted === void 0 ? void 0 : quoted.toExact())) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: [
                                    "~$",
                                    (0,formatBalance/* formatNumber */.uf)(+quoted.toExact())
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/utils/currencyId.ts
var currencyId = __webpack_require__(28996);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/useCurrencySelectRoute.ts




var useCurrencySelectRoute = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(router.query.currency || [], 2), currencyIdA = ref[0], currencyIdB = ref[1];
    var handleCurrencyASelect = (0,react.useCallback)(function(currencyA_) {
        var newCurrencyIdA = (0,currencyId/* default */.Z)(currencyA_);
        if (newCurrencyIdA === currencyIdB) {
            router.replace("/add/".concat(currencyIdB, "/").concat(currencyIdA), undefined, {
                shallow: true
            });
        } else if (currencyIdB) {
            router.replace("/add/".concat(newCurrencyIdA, "/").concat(currencyIdB), undefined, {
                shallow: true
            });
        } else {
            router.replace("/add/".concat(newCurrencyIdA), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdB,
        router,
        currencyIdA
    ]);
    var handleCurrencyBSelect = (0,react.useCallback)(function(currencyB_) {
        var newCurrencyIdB = (0,currencyId/* default */.Z)(currencyB_);
        if (currencyIdA === newCurrencyIdB) {
            if (currencyIdB) {
                router.replace("/add/".concat(currencyIdB, "/").concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            } else {
                router.replace("/add/".concat(newCurrencyIdB), undefined, {
                    shallow: true
                });
            }
        } else {
            router.replace("/add/".concat(currencyIdA || "BNB", "/").concat(newCurrencyIdB), undefined, {
                shallow: true
            });
        }
    }, [
        currencyIdA,
        router,
        currencyIdB
    ]);
    return {
        handleCurrencyASelect: handleCurrencyASelect,
        handleCurrencyBSelect: handleCurrencyBSelect
    };
};

;// CONCATENATED MODULE: ./src/views/AddLiquidity/ChoosePair.tsx









function ChoosePair(param) {
    var currencyA = param.currencyA, currencyB = param.currencyB, error = param.error, onNext = param.onNext;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var isValid = !error;
    var ref = useCurrencySelectRoute(), handleCurrencyASelect = ref.handleCurrencyASelect, handleCurrencyBSelect = ref.handleCurrencyBSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                title: t("Add Liquidity"),
                subtitle: t("Receive LP tokens and earn 0.17% trading fees"),
                helper: t("Liquidity providers earn a 0.17% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                backTo: "/liquidity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textTransform: "uppercase",
                            color: "secondary",
                            bold: true,
                            small: true,
                            pb: "24px",
                            children: t("Choose a valid pair")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                            gap: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokena",
                                    selectedCurrency: currencyA,
                                    onCurrencySelect: handleCurrencyASelect,
                                    showCommonBases: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "textSubtle"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelect, {
                                    id: "add-liquidity-select-tokenb",
                                    selectedCurrency: currencyB,
                                    onCurrencySelect: handleCurrencyBSelect,
                                    showCommonBases: true
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                    width: "100%"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    "data-test": "choose-pair-next",
                    width: "100%",
                    variant: !isValid ? "danger" : "primary",
                    onClick: onNext,
                    disabled: !isValid,
                    children: error !== null && error !== void 0 ? error : t("Add Liquidity")
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/ZapCheckbox.tsx
var ZapCheckbox = __webpack_require__(14984);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(56245);
;// CONCATENATED MODULE: ./src/views/AddLiquidity/index.tsx
























































var Steps;
(function(Steps) {
    Steps[Steps["Choose"] = 0] = "Choose";
    Steps[Steps["Add"] = 1] = "Add";
})(Steps || (Steps = {}));
var zapAddress = (0,addressHelpers/* getZapAddress */._M)();
function AddLiquidity() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var router = (0,next_router.useRouter)();
    var ref29 = (0,useActiveWeb3React/* default */.Z)(), account = ref29.account, chainId = ref29.chainId, library = ref29.library;
    var expertMode = (0,user_hooks/* useIsExpertMode */.LO)();
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useZapModeManager */.$f)(), 1), zapMode = ref30[0];
    var ref31 = (0,react.useState)(true), temporarilyZapMode = ref31[0], setTemporarilyZapMode = ref31[1];
    var ref32 = (0,_sliced_to_array/* default */.Z)(router.query.currency || [
        "BNB",
        (ref = tokens/* bscTokens.bnou */.ds.bnou) === null || ref === void 0 ? void 0 : ref.address
    ], 2), currencyIdA = ref32[0], currencyIdB = ref32[1];
    var ref33 = (0,react.useState)(Steps.Choose), steps = ref33[0], setSteps = ref33[1];
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var currencyA = (0,Tokens/* useCurrency */.U8)(currencyIdA);
    var currencyB = (0,Tokens/* useCurrency */.U8)(currencyIdB);
    (0,react.useEffect)(function() {
        if (!currencyIdA && !currencyIdB) {
            dispatch((0,actions/* resetMintState */.dA)());
        }
    }, [
        dispatch,
        currencyIdA,
        currencyIdB
    ]);
    (0,react.useEffect)(function() {
        if (router.query.step === "1") {
            setSteps(Steps.Add);
        }
    }, [
        router.query
    ]);
    var zapModeStatus = (0,react.useMemo)(function() {
        return !!zapMode && temporarilyZapMode;
    }, [
        zapMode,
        temporarilyZapMode
    ]);
    // mint state
    var ref34 = useMintState(), independentField = ref34.independentField, typedValue = ref34.typedValue, otherTypedValue = ref34.otherTypedValue;
    var ref35 = useDerivedMintInfo(currencyA !== null && currencyA !== void 0 ? currencyA : undefined, currencyB !== null && currencyB !== void 0 ? currencyB : undefined), dependentField = ref35.dependentField, currencies = ref35.currencies, pair = ref35.pair, pairState = ref35.pairState, currencyBalances = ref35.currencyBalances, mintParsedAmounts = ref35.parsedAmounts, price = ref35.price, noLiquidity = ref35.noLiquidity, liquidityMinted = ref35.liquidityMinted, poolTokenPercentage = ref35.poolTokenPercentage, error = ref35.error, addError = ref35.addError;
    var poolData = (0,hooks/* useLPApr */.aT)(pair);
    var ref36 = (0,useTooltip/* default */.Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref36.targetRef, tooltip = ref36.tooltip, tooltipVisible = ref36.tooltipVisible;
    var ref37 = useMintActionHandlers(noLiquidity), onFieldAInput = ref37.onFieldAInput, onFieldBInput = ref37.onFieldBInput;
    // modal and loading
    var ref38 = (0,react.useState)({
        attemptingTxn: false,
        liquidityErrorMessage: undefined,
        txHash: undefined
    }), ref39 = ref38[0], attemptingTxn = ref39.attemptingTxn, liquidityErrorMessage = ref39.liquidityErrorMessage, txHash = ref39.txHash, setLiquidityState = ref38[1];
    // Zap state
    var ref40 = (0,react.useState)(true), zapTokenToggleA = ref40[0], setZapTokenToggleA = ref40[1];
    var ref41 = (0,react.useState)(true), zapTokenToggleB = ref41[0], setZapTokenToggleB = ref41[1];
    var zapTokenCheckedA = zapTokenToggleA && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref1 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.greaterThan(0));
    var zapTokenCheckedB = zapTokenToggleB && (currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref2 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.greaterThan(0));
    // txn values
    var deadline = (0,useTransactionDeadline/* default */.Z)() // custom from users settings
    ;
    var ref42 // custom from users
     = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref42[0];
    // get the max amounts user can add
    var maxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[field])));
    }, {});
    var canZap = (0,react.useMemo)(function() {
        return !!zapModeStatus && !noLiquidity && !(pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve0.raw, src/* MINIMUM_LIQUIDITY */.Xh) || pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve1.raw, src/* MINIMUM_LIQUIDITY */.Xh));
    }, [
        noLiquidity,
        pair,
        zapModeStatus
    ]);
    var ref43 = useCurrencySelectRoute(), handleCurrencyASelect = ref43.handleCurrencyASelect, handleCurrencyBSelect = ref43.handleCurrencyBSelect;
    var _ref = useZapIn({
        pair: pair,
        canZap: canZap,
        currencyA: currencyA,
        currencyB: currencyB,
        currencyBalances: currencyBalances,
        zapTokenCheckedA: zapTokenCheckedA,
        zapTokenCheckedB: zapTokenCheckedB,
        maxAmounts: maxAmounts
    }), zapInEstimating = _ref.zapInEstimating, rebalancing = _ref.rebalancing, zapIn = (0,_object_without_properties/* default */.Z)(_ref, [
        "zapInEstimating",
        "rebalancing"
    ]);
    var parsedAmounts = canZap ? zapIn.parsedAmounts : mintParsedAmounts;
    var preferZapInstead = canZap && !zapIn.noNeedZap;
    var ref44;
    // get formatted amounts
    var formattedAmounts = (0,react.useMemo)(function() {
        var ref;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, independentField, canZap && (independentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A && !zapTokenCheckedA || independentField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B && !zapTokenCheckedB) ? "" : typedValue), (0,_define_property/* default */.Z)(_obj, dependentField, noLiquidity ? otherTypedValue : (ref44 = (ref = parsedAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref44 !== void 0 ? ref44 : ""), _obj;
    }, [
        canZap,
        dependentField,
        independentField,
        noLiquidity,
        otherTypedValue,
        parsedAmounts,
        typedValue,
        zapTokenCheckedA,
        zapTokenCheckedB, 
    ]);
    var atMaxAmounts = [
        actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
        actions/* Field.CURRENCY_B */.gN.CURRENCY_B
    ].reduce(function(accumulator, field) {
        var ref;
        var _field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, field, (ref = maxAmounts[field]) === null || ref === void 0 ? void 0 : ref.equalTo((_field = parsedAmounts[field]) !== null && _field !== void 0 ? _field : "0")));
    }, {});
    // check whether the user has approved the router on the tokens
    var ref45 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalA = ref45[0], approveACallback = ref45[1];
    var ref46 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallback */.qL)(parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], preferZapInstead ? zapAddress : exchange/* ROUTER_ADDRESS */.bR[chainId]), 2), approvalB = ref46[0], approveBCallback = ref46[1];
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    function onAdd() {
        return _onAdd.apply(this, arguments);
    }
    function _onAdd() {
        _onAdd = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var routerContract, parsedAmountA, parsedAmountB, _obj, amountsMin, estimate, method, args, value, ref, tokenBIsBNB, ref1, ref2, ref3, ref4, ref5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!chainId || !library || !account)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        routerContract = (0,utils_exchange/* getRouterContract */.iY)(chainId, library, account);
                        parsedAmountA = mintParsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], parsedAmountB = mintParsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
                        if (!(!parsedAmountA || !parsedAmountB || !currencyA || !currencyB || !deadline)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        ;
                        amountsMin = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_A */.gN.CURRENCY_A, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountA, noLiquidity ? 0 : allowedSlippage)[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.CURRENCY_B */.gN.CURRENCY_B, (0,utils_exchange/* calculateSlippageAmount */.uc)(parsedAmountB, noLiquidity ? 0 : allowedSlippage)[0]), _obj);
                        ;
                        ;
                        ;
                        ;
                        if (currencyA === src/* ETHER */.c0 || currencyB === src/* ETHER */.c0) {
                            ;
                            tokenBIsBNB = currencyB === src/* ETHER */.c0;
                            estimate = routerContract.estimateGas.addLiquidityETH;
                            method = routerContract.addLiquidityETH;
                            ;
                            args = [
                                (ref1 = (ref = (0,wrappedCurrency/* wrappedCurrency */.pu)(tokenBIsBNB ? currencyA : currencyB, chainId)) === null || ref === void 0 ? void 0 : ref.address) !== null && ref1 !== void 0 ? ref1 : "",
                                (tokenBIsBNB ? parsedAmountA : parsedAmountB).raw.toString(),
                                amountsMin[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                amountsMin[tokenBIsBNB ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = bignumber/* BigNumber.from */.O$.from((tokenBIsBNB ? parsedAmountB : parsedAmountA).raw.toString());
                        } else {
                            ;
                            estimate = routerContract.estimateGas.addLiquidity;
                            method = routerContract.addLiquidity;
                            ;
                            args = [
                                (ref4 = (ref2 = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId)) === null || ref2 === void 0 ? void 0 : ref2.address) !== null && ref4 !== void 0 ? ref4 : "",
                                (ref5 = (ref3 = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)) === null || ref3 === void 0 ? void 0 : ref3.address) !== null && ref5 !== void 0 ? ref5 : "",
                                parsedAmountA.raw.toString(),
                                parsedAmountB.raw.toString(),
                                amountsMin[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].toString(),
                                amountsMin[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].toString(),
                                account,
                                deadline.toHexString(), 
                            ];
                            value = null;
                        }
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        _ctx.next = 16;
                        return estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                            value ? {
                                value: value
                            } : {}
                        ])).then(function(estimatedGasLimit) {
                            return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value ? {
                                    value: value
                                } : {}), {
                                    gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                    gasPrice: gasPrice
                                })
                            ])).then(function(response) {
                                var ref, ref1, ref2, ref3;
                                setLiquidityState({
                                    attemptingTxn: false,
                                    liquidityErrorMessage: undefined,
                                    txHash: response.hash
                                });
                                addTransaction(response, {
                                    summary: "Add ".concat((ref = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(3), " ").concat((ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol, " and ").concat((ref2 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(3), " ").concat((ref3 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol),
                                    type: "add-liquidity"
                                });
                            });
                        }).catch(function(err) {
                            if (err && err.code !== 4001) {
                                (0,sentry/* logError */.H)(err);
                                console.error("Add Liquidity failed", err, args, value);
                            }
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: err && err.code !== 4001 ? t("Add liquidity failed: %message%", {
                                    message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                }) : undefined,
                                txHash: undefined
                            });
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onAdd.apply(this, arguments);
    }
    var ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54;
    var pendingText = preferZapInstead ? t("Zapping %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref47 = (ref3 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(6)) !== null && ref47 !== void 0 ? ref47 : "0",
        symbolA: (ref48 = (ref4 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref4 === void 0 ? void 0 : ref4.symbol) !== null && ref48 !== void 0 ? ref48 : "",
        amountB: (ref49 = (ref5 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref5 === void 0 ? void 0 : ref5.toSignificant(6)) !== null && ref49 !== void 0 ? ref49 : "0",
        symbolB: (ref50 = (ref6 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref6 === void 0 ? void 0 : ref6.symbol) !== null && ref50 !== void 0 ? ref50 : ""
    }) : t("Supplying %amountA% %symbolA% and %amountB% %symbolB%", {
        amountA: (ref51 = (ref7 = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref7 === void 0 ? void 0 : ref7.toSignificant(6)) !== null && ref51 !== void 0 ? ref51 : "",
        symbolA: (ref52 = (ref8 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref8 === void 0 ? void 0 : ref8.symbol) !== null && ref52 !== void 0 ? ref52 : "",
        amountB: (ref53 = (ref9 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref9 === void 0 ? void 0 : ref9.toSignificant(6)) !== null && ref53 !== void 0 ? ref53 : "",
        symbolB: (ref54 = (ref10 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref10 === void 0 ? void 0 : ref10.symbol) !== null && ref54 !== void 0 ? ref54 : ""
    });
    var handleDismissConfirmation = (0,react.useCallback)(function() {
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onFieldAInput("");
        }
    }, [
        onFieldAInput,
        txHash
    ]);
    var addIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var addIsWarning = (0,Trades/* useIsTransactionWarning */.uK)(currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_A, currencies === null || currencies === void 0 ? void 0 : currencies.CURRENCY_B);
    var zapContract = (0,useContract/* useZapContract */.n9)(true);
    var ref55 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmAddLiquidityModal, {
        title: noLiquidity ? t("You are creating a pool") : t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        currencyToAdd: pair === null || pair === void 0 ? void 0 : pair.liquidityToken,
        allowedSlippage: allowedSlippage,
        onAdd: onAdd,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        noLiquidity: noLiquidity,
        poolTokenPercentage: poolTokenPercentage,
        liquidityMinted: liquidityMinted
    }), true, true, "addLiquidityModal"), 1), onPresentAddLiquidityModal = ref55[0];
    function onZapIn() {
        return _onZapIn.apply(this, arguments);
    }
    function _onZapIn() {
        _onZapIn = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var method, args, value, summary, minAmountOut, ref, ref1, ref2, ref3, maxAmountIn, tokenBIsBNB, ref4, ref5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!canZap || !parsedAmounts || !zapIn.zapInEstimated || !library || !chainId)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        ;
                        ;
                        ;
                        ;
                        minAmountOut = zapIn.zapInEstimated.swapAmountOut.mul(10000 - allowedSlippage).div(10000);
                        if (rebalancing) {
                            ;
                            maxAmountIn = zapIn.zapInEstimated.swapAmountIn.mul(10000 + allowedSlippage).div(10000);
                            summary = "Zap ".concat((ref = parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toSignificant(3), " ").concat((ref1 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.symbol, " and ").concat((ref2 = parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(3), " ").concat((ref3 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref3 === void 0 ? void 0 : ref3.symbol);
                            if (currencyA === src/* ETHER */.c0 || currencyB === src/* ETHER */.c0) {
                                tokenBIsBNB = currencyB === src/* ETHER */.c0;
                                method = "zapInBNBRebalancing";
                                args = [
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                                    parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_A */.gN.CURRENCY_A : actions/* Field.CURRENCY_B */.gN.CURRENCY_B].raw.toString(),
                                    pair.liquidityToken.address,
                                    maxAmountIn,
                                    minAmountOut,
                                    zapIn.zapInEstimated.isToken0Sold && !tokenBIsBNB
                                ];
                                value = parsedAmounts[tokenBIsBNB ? actions/* Field.CURRENCY_B */.gN.CURRENCY_B : actions/* Field.CURRENCY_A */.gN.CURRENCY_A].raw.toString();
                            } else {
                                method = "zapInTokenRebalancing";
                                args = [
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A], chainId).address,
                                    (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B], chainId).address,
                                    parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].raw.toString(),
                                    parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].raw.toString(),
                                    pair.liquidityToken.address,
                                    maxAmountIn,
                                    minAmountOut,
                                    zapIn.zapInEstimated.isToken0Sold
                                ];
                            }
                        } else if (currencies[zapIn.swapTokenField] === src/* ETHER */.c0) {
                            ;
                            method = "zapInBNB";
                            args = [
                                pair.liquidityToken.address,
                                minAmountOut
                            ];
                            summary = "Zap in ".concat((ref4 = parsedAmounts[zapIn.swapTokenField]) === null || ref4 === void 0 ? void 0 : ref4.toSignificant(3), " BNB for ").concat((0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol));
                            value = parsedAmounts[zapIn.swapTokenField].raw.toString();
                        } else {
                            ;
                            method = "zapInToken";
                            args = [
                                (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies[zapIn.swapTokenField], chainId).address,
                                parsedAmounts[zapIn.swapTokenField].raw.toString(),
                                pair.liquidityToken.address,
                                minAmountOut, 
                            ];
                            summary = "Zap in ".concat((ref5 = parsedAmounts[zapIn.swapTokenField]) === null || ref5 === void 0 ? void 0 : ref5.toSignificant(3), " ").concat(currencies[zapIn.swapTokenField].symbol, " for ").concat((0,getLpSymbol/* getLPSymbol */.z)(pair.token0.symbol, pair.token1.symbol));
                        }
                        setLiquidityState({
                            attemptingTxn: true,
                            liquidityErrorMessage: undefined,
                            txHash: undefined
                        });
                        (0,calls/* callWithEstimateGas */.Zj)(zapContract, method, args, value ? {
                            value: value,
                            gasPrice: gasPrice
                        } : {
                            gasPrice: gasPrice
                        }).then(function(response) {
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: undefined,
                                txHash: response.hash
                            });
                            addTransaction(response, {
                                summary: summary,
                                type: "add-liquidity"
                            });
                        }).catch(function(err) {
                            if (err && err.code !== 4001) {
                                (0,sentry/* logError */.H)(err);
                                console.error("Add Liquidity failed", err, args, value);
                            }
                            setLiquidityState({
                                attemptingTxn: false,
                                liquidityErrorMessage: err && err.code !== 4001 ? "Add Liquidity failed: ".concat(err.message) : undefined,
                                txHash: undefined
                            });
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _onZapIn.apply(this, arguments);
    }
    var ref56 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmZapInModal, {
        title: t("You will receive"),
        customOnDismiss: handleDismissConfirmation,
        attemptingTxn: attemptingTxn,
        hash: txHash,
        pendingText: pendingText,
        pair: pair,
        allowedSlippage: allowedSlippage,
        onAdd: onZapIn,
        parsedAmounts: parsedAmounts,
        currencies: currencies,
        liquidityErrorMessage: liquidityErrorMessage,
        price: price,
        poolTokenPercentage: zapIn.poolTokenPercentage,
        liquidityMinted: zapIn.liquidityMinted,
        zapSwapTokenField: zapIn.swapTokenField,
        zapSwapOutTokenField: zapIn.swapOutTokenField,
        zapInEstimated: zapIn.zapInEstimated,
        rebalancing: rebalancing,
        zapMode: zapModeStatus,
        toggleZapMode: setTemporarilyZapMode
    }), true, true, "zapInModal"), 1), onPresentZapInModal = ref56[0];
    var handleEnableZap = function() {
        if (!zapMode) {
            setTemporarilyZapMode(!zapMode);
        }
    };
    var isValid = !error;
    var errorText = error;
    if (preferZapInstead) {
        isValid = !error && !zapIn.error;
        errorText = error !== null && error !== void 0 ? error : zapIn.error;
    } else {
        isValid = !error && !addError;
        errorText = error !== null && error !== void 0 ? error : addError;
    }
    var buttonDisabled = !isValid || (zapIn.parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] || !preferZapInstead && zapTokenCheckedA) && approvalA !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || (zapIn.parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] || !preferZapInstead && zapTokenCheckedB) && approvalB !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || zapIn.priceSeverity > 3 && preferZapInstead;
    var showFieldAApproval = (zapTokenCheckedA || !preferZapInstead) && (approvalA === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var showFieldBApproval = (zapTokenCheckedB || !preferZapInstead) && (approvalB === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var shouldShowApprovalGroup = (showFieldAApproval || showFieldBApproval) && isValid;
    var oneCurrencyIsWBNB = Boolean(chainId && (currencyA && (0,src/* currencyEquals */.KA)(currencyA, src/* WNATIVE */.FX[chainId]) || currencyB && (0,src/* currencyEquals */.KA)(currencyB, src/* WNATIVE */.FX[chainId])));
    var noAnyInputAmount = !parsedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !parsedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B];
    var showAddLiquidity = !!currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && !!currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && steps === Steps.Add || !canZap;
    var showZapWarning = preferZapInstead && !noAnyInputAmount && (!rebalancing && !(!zapTokenCheckedA && !zapTokenCheckedB) || rebalancing && zapIn.priceSeverity > 3);
    var showReduceZapTokenButton = preferZapInstead && (zapIn.priceSeverity > 3 || zapIn.zapInEstimatedError) && maxAmounts[zapIn.swapTokenField];
    var showRebalancingConvert = !showZapWarning && !noAnyInputAmount && !showReduceZapTokenButton && preferZapInstead && zapIn.isDependentAmountGreaterThanMaxAmount && rebalancing;
    var showZapIsAvailable = !zapMode && !showZapWarning && !noAnyInputAmount && (!zapTokenCheckedA || !zapTokenCheckedB) && !noLiquidity && !(pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve0.raw, src/* MINIMUM_LIQUIDITY */.Xh) || pair && src/* JSBI.lessThan */.QA.lessThan(pair.reserve1.raw, src/* MINIMUM_LIQUIDITY */.Xh));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                children: [
                    !showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoosePair, {
                        error: error,
                        currencyA: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                        currencyB: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                        onNext: function() {
                            return setSteps(Steps.Add);
                        }
                    }),
                    showAddLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppHeader */.t, {
                                title: ((ref11 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref11 === void 0 ? void 0 : ref11.symbol) && ((ref12 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref12 === void 0 ? void 0 : ref12.symbol) ? "".concat((0,getLpSymbol/* getLPSymbol */.z)(currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A].symbol, currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B].symbol)) : t("Add Liquidity"),
                                subtitle: t("Receive LP tokens and earn 0.17% trading fees"),
                                helper: t("Liquidity providers earn a 0.17% trading fee on all trades made for that token pair, proportional to their share of the liquidity pool."),
                                backTo: canZap ? function() {
                                    return setSteps(Steps.Choose);
                                } : "/liquidity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                    gap: "20px",
                                    children: [
                                        noLiquidity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                                variant: "warning",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            bold: true,
                                                            mb: "8px",
                                                            children: t("You are the first liquidity provider.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            mb: "8px",
                                                            children: t("The ratio of tokens you add will set the price of this pool.")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: t("Once you are happy with the rate click supply to review.")
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            disableCurrencySelect: canZap,
                                            showBUSD: true,
                                            onInputBlur: zapIn.onInputBlurOnce,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A,
                                            disabled: canZap && !zapTokenCheckedA,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref13 = currencyBalances[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref13 === void 0 ? void 0 : ref13.equalTo(0),
                                                checked: zapTokenCheckedA,
                                                onChange: function(e) {
                                                    setZapTokenToggleA(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyASelect,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            onUserInput: onFieldAInput,
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldAInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            currency: currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A],
                                            id: "add-liquidity-input-tokena",
                                            showCommonBases: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* ColumnCenter */.lg, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                                width: "16px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                            showBUSD: true,
                                            onInputBlur: zapIn.onInputBlurOnce,
                                            disabled: canZap && !zapTokenCheckedB,
                                            error: zapIn.priceSeverity > 3 && zapIn.swapTokenField === actions/* Field.CURRENCY_B */.gN.CURRENCY_B,
                                            beforeButton: canZap && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZapCheckbox/* ZapCheckbox */.y, {
                                                disabled: currencyBalances === null || currencyBalances === void 0 ? void 0 : (ref14 = currencyBalances[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref14 === void 0 ? void 0 : ref14.equalTo(0),
                                                checked: zapTokenCheckedB,
                                                onChange: function(e) {
                                                    setZapTokenToggleB(e.target.checked);
                                                }
                                            }),
                                            onCurrencySelect: handleCurrencyBSelect,
                                            disableCurrencySelect: canZap,
                                            zapStyle: canZap ? "zap" : "noZap",
                                            value: formattedAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            onUserInput: onFieldBInput,
                                            onMax: function() {
                                                var ref;
                                                var ref1;
                                                onFieldBInput((ref1 = (ref = maxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                            },
                                            showMaxButton: !atMaxAmounts[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            currency: currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B],
                                            id: "add-liquidity-input-tokenb"
                                        }),
                                        showZapWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: zapIn.priceSeverity > 3 ? "danger" : "warning",
                                            children: zapIn.priceSeverity > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Price Impact Too Hight."),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("Reduce amount of %token% to maximum limit", {
                                                            token: (ref15 = currencies[zapIn.swapTokenField]) === null || ref15 === void 0 ? void 0 : ref15.symbol
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: t("No %token% input.", {
                                                            token: (ref16 = currencies[zapIn.swapOutTokenField]) === null || ref16 === void 0 ? void 0 : ref16.symbol
                                                        })
                                                    }),
                                                    " ",
                                                    t("Some of your %token0% will be converted to %token1%.", {
                                                        token0: (ref17 = currencies[zapIn.swapTokenField]) === null || ref17 === void 0 ? void 0 : ref17.symbol,
                                                        token1: (ref18 = currencies[zapIn.swapOutTokenField]) === null || ref18 === void 0 ? void 0 : ref18.symbol
                                                    })
                                                ]
                                            })
                                        }),
                                        showReduceZapTokenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                return zapIn.convertToMaxZappable();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Reduce %token%", {
                                                    token: (ref19 = currencies[zapIn.swapTokenField]) === null || ref19 === void 0 ? void 0 : ref19.symbol
                                                })
                                            })
                                        }),
                                        showZapIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                children: [
                                                    t("Zap allows you to add liquidity with only 1 single token. Click"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        p: "0 4px",
                                                        scale: "sm",
                                                        variant: "text",
                                                        height: "auto",
                                                        onClick: handleEnableZap,
                                                        children: t("here")
                                                    }),
                                                    t("to try.")
                                                ]
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                            variant: "warning",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("Not enough %token%.", {
                                                                token: (ref20 = currencies[zapIn.swapOutTokenField]) === null || ref20 === void 0 ? void 0 : ref20.symbol
                                                            })
                                                        }),
                                                        " ",
                                                        zapIn.gasOverhead ? t("Some of your %token0% will be converted to %token1% before adding liquidity, but this may cause higher gas fees.", {
                                                            token0: (ref21 = currencies[zapIn.swapTokenField]) === null || ref21 === void 0 ? void 0 : ref21.symbol,
                                                            token1: (ref22 = currencies[zapIn.swapOutTokenField]) === null || ref22 === void 0 ? void 0 : ref22.symbol
                                                        }) : t("Some of your %token0% will be converted to %token1%.", {
                                                            token0: (ref23 = currencies[zapIn.swapTokenField]) === null || ref23 === void 0 ? void 0 : ref23.symbol,
                                                            token1: (ref24 = currencies[zapIn.swapOutTokenField]) === null || ref24 === void 0 ? void 0 : ref24.symbol
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        showRebalancingConvert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                                            style: {
                                                margin: "auto"
                                            },
                                            onClick: function() {
                                                if (dependentField === actions/* Field.CURRENCY_A */.gN.CURRENCY_A) {
                                                    var ref;
                                                    var ref1;
                                                    onFieldAInput((ref1 = (ref = maxAmounts[dependentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref1 !== void 0 ? ref1 : "");
                                                } else {
                                                    var ref2;
                                                    var ref3;
                                                    onFieldBInput((ref3 = (ref2 = maxAmounts[dependentField]) === null || ref2 === void 0 ? void 0 : ref2.toExact()) !== null && ref3 !== void 0 ? ref3 : "");
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary",
                                                scale: "sm",
                                                children: t("Don\u2019t convert")
                                            })
                                        }),
                                        currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A] && currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B] && pairState !== usePairs/* PairState.INVALID */._G.INVALID && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightCard */.hl, {
                                                padding: "0px",
                                                borderRadius: "20px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                                        padding: "1rem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "14px",
                                                            children: noLiquidity ? t("Initial prices and pool share") : t("Prices and pool share")
                                                        })
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* LightCard */.hl, {
                                                        padding: "1rem",
                                                        borderRadius: "20px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddLiquidity_PoolPriceBar, {
                                                            currencies: currencies,
                                                            poolTokenPercentage: preferZapInstead ? zapIn.poolTokenPercentage : poolTokenPercentage,
                                                            noLiquidity: noLiquidity,
                                                            price: price
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("Slippage Tolerance")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        allowedSlippage / 100,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        pair && poolData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                                    ref: targetRef,
                                                    bold: true,
                                                    fontSize: "12px",
                                                    color: "secondary",
                                                    children: t("LP reward APR")
                                                }),
                                                tooltipVisible && tooltip,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    bold: true,
                                                    color: "primary",
                                                    children: [
                                                        (0,formatInfoNumbers/* formatAmount */.d)(poolData.lpApr7d),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        addIsUnsupported || addIsWarning ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            disabled: true,
                                            mb: "4px",
                                            children: t("Unsupported Asset")
                                        }) : !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                            gap: "md",
                                            children: [
                                                shouldShowApprovalGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                    style: {
                                                        gap: "8px"
                                                    },
                                                    children: [
                                                        showFieldAApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveACallback,
                                                            disabled: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalA === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref25 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref25 === void 0 ? void 0 : ref25.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref26 = currencies[actions/* Field.CURRENCY_A */.gN.CURRENCY_A]) === null || ref26 === void 0 ? void 0 : ref26.symbol
                                                            })
                                                        }),
                                                        showFieldBApproval && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: approveBCallback,
                                                            disabled: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING,
                                                            width: "100%",
                                                            children: approvalB === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                                                children: t("Enabling %asset%", {
                                                                    asset: (ref27 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref27 === void 0 ? void 0 : ref27.symbol
                                                                })
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref28 = currencies[actions/* Field.CURRENCY_B */.gN.CURRENCY_B]) === null || ref28 === void 0 ? void 0 : ref28.symbol
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    isLoading: preferZapInstead && zapInEstimating,
                                                    variant: !isValid || zapIn.priceSeverity > 2 ? "danger" : "primary",
                                                    onClick: function() {
                                                        if (preferZapInstead) {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentZapInModal();
                                                            return;
                                                        }
                                                        if (expertMode) {
                                                            onAdd();
                                                        } else {
                                                            setLiquidityState({
                                                                attemptingTxn: false,
                                                                liquidityErrorMessage: undefined,
                                                                txHash: undefined
                                                            });
                                                            onPresentAddLiquidityModal();
                                                        }
                                                    },
                                                    disabled: buttonDisabled,
                                                    children: errorText || t("Supply")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !(addIsUnsupported || addIsWarning) ? pair && !noLiquidity && pairState !== usePairs/* PairState.INVALID */._G.INVALID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                style: {
                    minWidth: "20rem",
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: "1rem"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionCard/* MinimalPositionCard */.W, {
                    showUnwrapped: oneCurrencyIsWBNB,
                    pair: pair
                })
            }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter/* default */.Z, {
                currencies: [
                    currencies.CURRENCY_A,
                    currencies.CURRENCY_B
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/add/[[...currency]].tsx

var __N_SSG = true;
/* harmony default export */ var _currency_ = (AddLiquidity);


/***/ }),

/***/ 16519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "sA": function() { return /* reexport */ harvestFarm; },
  "AQ": function() { return /* reexport */ stakeFarm; },
  "dU": function() { return /* reexport */ unstakeFarm; }
});

// UNUSED EXPORTS: estimateGas, getActivePools

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 ? _args[4] : void 0;
                    ;
                    if (contract[methodName]) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                case 4:
                    _ctx.next = 6;
                    return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        overrides
                    ]));
                case 6:
                    rawGasEstimation = _ctx.sent;
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return _ctx.abrupt("return", gasEstimation);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 1000;
                    ;
                    _ctx.next = 4;
                    return estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000);
                case 4:
                    gasEstimation = _ctx.sent;
                    _ctx.next = 7;
                    return (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        (0,_object_spread/* default */.Z)({
                            gasLimit: gasEstimation
                        }, overrides)
                    ]));
                case 7:
                    tx = _ctx.sent;
                    return _ctx.abrupt("return", tx);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./src/utils/getGasPrice.ts
var getGasPrice = __webpack_require__(76582);
;// CONCATENATED MODULE: ./src/utils/calls/farms.ts







var options = {
    gasLimit: config/* DEFAULT_GAS_LIMIT */.QL
};
var stakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid, amount) {
        var gasPrice, value;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function stakeFarm(masterChefContract, pid, amount) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid, amount) {
        var gasPrice, value;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return _ctx.abrupt("return", masterChefContract.withdraw(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function unstakeFarm(masterChefContract, pid, amount) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid) {
        var gasPrice;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, "0", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestFarm(masterChefContract, pid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/utils/providers.ts + 1 modules
var providers = __webpack_require__(65684);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(55878);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts




/* eslint-disable import/prefer-default-export */ 





/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var eligiblePools, blockNumber, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _ctx.t0 = block;
                    if (_ctx.t0) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 5;
                    return providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber();
                case 5:
                    _ctx.t0 = _ctx.sent;
                case 6:
                    blockNumber = _ctx.t0;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    _ctx.t1 = _sliced_to_array/* default */.Z;
                    _ctx.next = 12;
                    return Promise.all([
                        (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                        (0,multicall/* default */.Z)(sousChefV2, endBlockCalls), 
                    ]);
                case 12:
                    _ctx.t2 = _ctx.sent;
                    ref = (0, _ctx.t1)(_ctx.t2, 2);
                    startBlocks = ref[0];
                    endBlocks = ref[1];
                    return _ctx.abrupt("return", eligiblePools.reduce(function(accum, poolCheck, index) {
                        var startBlock = startBlocks[index] ? new (bignumber_default())(startBlocks[index]) : null;
                        var endBlock = endBlocks[index] ? new (bignumber_default())(endBlocks[index]) : null;
                        if (!startBlock || !endBlock) {
                            return accum;
                        }
                        if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                            return accum;
                        }
                        return (0,_to_consumable_array/* default */.Z)(accum).concat([
                            poolCheck
                        ]);
                    }, []));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 76582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46506);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45101);



/**
 * @deprecated not recommend to get state out of redux hook
 * Function to return gasPrice outwith a react component
 */ var getGasPrice = function() {
    var chainId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC;
    var state = state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .ZP.getState();
    var userGas = state.user.gasPrice || state_types__WEBPACK_IMPORTED_MODULE_2__/* .GAS_PRICE_GWEI["default"] */ .j4["default"];
    return chainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC ? userGas : state_types__WEBPACK_IMPORTED_MODULE_2__/* .GAS_PRICE_GWEI.testnet */ .j4.testnet;
};
/* harmony default export */ __webpack_exports__["Z"] = (getGasPrice);


/***/ }),

/***/ 63119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLPSymbol; }
/* harmony export */ });
var getLPSymbol = function(token0Symbol, token1Symbol) {
    if (token0Symbol === "WBNB") {
        return "BNB-".concat(token1Symbol, " LP");
    }
    if (token1Symbol === "WBNB") {
        return "".concat(token0Symbol, "-BNB LP");
    }
    return "".concat(token0Symbol, "-").concat(token1Symbol, " LP");
};


/***/ }),

/***/ 45131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19838);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    if (!currencyAmount) return undefined;
    if (currencyAmount.currency === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ETHER */ .c0) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.raw, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.raw, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 42808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ transactionErrorToUserReadableMessage; }
/* harmony export */ });
/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 */ function transactionErrorToUserReadableMessage(error, t) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3;
        reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "PancakeRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "PancakeRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "PancakeRouter: EXCESSIVE_INPUT_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_A_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_B_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Pancake: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}


/***/ }),

/***/ 52631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ZapErrorMessages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67334);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8253);
/* harmony import */ var hooks_useToast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);





var ZapErrorMessages = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var isSingleToken = param.isSingleToken, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode, onModalDismiss = param.onModalDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var toastInfo = (0,hooks_useToast__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().toastInfo;
    var handleCloseButton = function() {
        onModalDismiss();
        if (zapMode) {
            toggleZapMode(!zapMode);
            toastInfo(t("Info"), t("Temporarily disabled Zap"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        width: [
            "100%",
            "100%",
            "380px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "warning",
            mb: "16px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        bold: true,
                        children: t("Currently using Zap for liquidity provisions.")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        small: true,
                        children: [
                            isSingleToken ? t("Zap does NOT support tokens with fees on transfers. If you experience any issues, click") : t("Zap does NOT support tokens with fees on transfers. Please choose \u2019Don't convert\u2019 and retry. If you experience any further issues, click"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                p: "0 4px",
                                scale: "sm",
                                variant: "text",
                                height: "auto",
                                onClick: handleCloseButton,
                                children: t("here")
                            }),
                            t("to disable Zap temporarily.")
                        ]
                    })
                ]
            })
        })
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7425,4165,5855,3750,561,5652,3439,7882,6323,9774,2888,179], function() { return __webpack_exec__(32990); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);